import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Dotdotdot from 'react-dotdotdot'
import classnames from 'classnames';
import { contacts } from '../../../../modules/customer/profile';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

class ContactListItem extends React.Component {
    // componentDidUpdate  () {
    //     if(this.props.isSelected(this.props.index)) {
    //         ReactDOM.findDOMNode(this).scrollIntoView();
    //     }
    // }
    render = () => {
        let isSelected = this.props.isSelected(this.props.index);
        let contactRowClasses = classnames('contact-list-item', { selected: isSelected});
        return <div className={contactRowClasses} onClick={this.props.rowClickHandler.bind(undefined, this.props.index)}>
            <div className="separator"></div>
            <div className="circle"></div>
            <div className="contact-date">
                {this.props.contact.createdAt}
            </div>
            <div className="contact-description"> 
                <Dotdotdot clamp={2}>
                    { this.props.comment }
                </Dotdotdot>
            </div>
        </div>
    }
}

const mapStateToProps = createStructuredSelector({
    isSelected: (idx) => contacts.selectors.isSelected(idx)
});

const mapDispatchToProps = dispatch => ({
    rowClickHandler: idx => dispatch(contacts.actions.selectContact(idx)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactListItem);